import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { LayoutType } from '../../../constants/LayoutConstants';
import { ArticleListItem } from './ArticleListItem';
import { Bouncer } from '../../../utils/Bouncer';
import { ArticleStore, ArticleItem } from '../../../stores/ArticleStore';
import { ViewSettingsActions } from '../../../actions/ViewSettingsActions';
import { ArticleActions } from '../../../actions/ArticleActions';
import { ProjectSettingsStore } from '../../../stores/ProjectSettingsStore';
import { UIHelper } from '../../../utils/UIHelper';
import { AppConfigurationStore } from '../../../stores/AppConfigurationStore';
import { HeaderButtonConfig } from '../../HeaderButtons';
import { ArticleListMaker } from '../../../utils/ArticleListMaker';
import { Price } from '../../Price';
import { SidebarHeader } from '../../SidebarHeader';

interface ArticleListProps extends React.Props<ArticleList> {
    visible: boolean;
    layoutType: LayoutType;
    showPrices: boolean;
}

interface ArticleListState {
    articleList: Array<ArticleItem>;
    currency: string;
}

export class ArticleList extends BaseComponent<ArticleListProps, ArticleListState> {
    private static updateBouncer: Bouncer<void> = new Bouncer<void>((): Promise<void> =>  {
        if (ArticleStore.getState().needsUpdate) {
            return ViewSettingsActions.withSidebarLock<void>((): Promise<void> => {
                return ArticleActions.updateArticleList();
            });
        }

        return Promise.resolve();
    });

    public render(): JSX.Element | null {
        if (!this.props.visible) {
            return null;
        }

        // FixMe: this isn't the right place to trigger actions
        if (ArticleStore.getState().needsUpdate) {
            ArticleList.updateBouncer.request().then(ArticleList.updateBouncer.run);
            setTimeout(() => {
                ArticleList.updateBouncer.run();
            });
        }

        let totalPrice: number = 0;

        const articles: Array<JSX.Element> = this.state.articleList.map((entry) => {
            totalPrice += ArticleListItem.getPrice(entry.properties);
            let inconsistencies: Array<string> = [];
            if (
                entry.properties &&
                entry.properties.article &&
                entry.properties.article.inconsistencyFlag &&
                entry.properties.article.inconsistencyReason &&
                entry.properties.article.inconsistencyReason[0]
            ) {
                inconsistencies = UIHelper.multilineTextToArray(entry.properties.article.inconsistencyReason[0]);
            }
            return (
                <ArticleListItem key={entry.properties.itemId} itemData={entry} showPrices={this.props.showPrices} inconsistencies={inconsistencies}/>
            );
        });

        const buttons: Array<HeaderButtonConfig> = this.buttons();
        return (
            <div className="sidebar-tab-container" key={this.props.layoutType.toString()}><div className="scrollbar-wcf">
                <SidebarHeader text={t('Article List')} buttons={buttons}/>
                <div className={'sidebar-content article-list' + (buttons.length > 0 ? ' button-header' : ' standard-header')}>
                    <div className="article-list-items select-allowed">
                        {articles}
                        {this.getFullPrice(totalPrice)}
                    </div>
                </div>
            </div></div>
        );
    }

    public componentWillMount(): void {
        this.addStoreListener(ArticleStore, this.onChange);
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    public componentDidUpdate(): void {
        if (this.props.visible) {
            UIHelper.updateScrollbar(
                ReactDOM.findDOMNode(this) as Element,
                (AppConfigurationStore.getState().inApp ? '.sidebar-content' : '.scrollbar-wcf')
            );
        }
    }

    protected onChange = (): void => {
        this.setState({
            articleList: ArticleStore.getState().articleList,
            currency: ProjectSettingsStore.getState().currency
        });
    };

    protected getFullPrice(totalPrice: number): JSX.Element | null {
        if (!this.props.showPrices || totalPrice <= 0) {
            return null;
        }
        return (
            <div className="articles-price">
                <div className="article-list-pricetext">{t('Price (excl. Tax)')}</div>
                <div className="article-list-fullprice">
                    <Price value={totalPrice} currency={this.state.currency} />
                </div>
            </div>
        );
    }

    protected buttons = (): Array<HeaderButtonConfig> => {
        if (AppConfigurationStore.getState().inApp && AppConfigurationStore.shareFormatAvailable('App')) {
            return [
                {stdClass: 'header-button-share', callback: () => { ArticleListMaker.share('PDF'); }, label: t('Share')}
            ];
        }

        if (AppConfigurationStore.shareFormatAvailable('Download')) {
            return [
                {stdClass: 'header-button-share', callback: () => { ArticleListMaker.download('PDF'); }, label: t('Download')}
            ];
        }

        return [];
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/articlelist/ArticleList.tsx